<template>
  <div class="soha-selected-filter">
    <limited-text :limit="30" :text="label" />
    <span
      class="svg-icon svg-icon-md svg-icon-secondary my-auto cursor-pointer ml-2"
      @click="$emit('click')"
    >
      <inline-svg src="/media/svg/soha/icons/times.svg" />
    </span>
  </div>
</template>

<script>
import "@/assets/css/components/resume/resume-selected-filter.css";
import LimitedText from "@/view/components/base/LimitedText";
export default {
  name: "ResumeSelectedFilter",
  components: { LimitedText },
  props: {
    label: {
      require: true,
      type: String,
    },
  },
};
</script>
